
<form [formGroup]="flightForm">
  <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
    <div class="d-flex align-items-center">

      <div class="form-check d-flex align-items-center me-3 mb-2">
        <input
          class="form-check-input mt-0"
          type="radio"
          id="roundtrip"
          formControlName="journeyType"
          [value]="journeyTypeEnum.ROUND_TRIP"
          [checked]="flightForm.value.journeyType === journeyTypeEnum.ROUND_TRIP"
        />
        <label class="form-check-label fs-14 ms-2" for="roundtrip">
          Round Trip
        </label>
      </div>
      <div class="form-check d-flex align-items-center me-3 mb-2">
        <input
          class="form-check-input mt-0"
          type="radio"
          id="oneway"
          formControlName="journeyType"
          [value]="journeyTypeEnum.ONEWAY"
          [checked]="flightForm.value.journeyType === journeyTypeEnum.ONEWAY"
        />
        <label class="form-check-label fs-14 ms-2" for="oneway">
          Oneway
        </label>
      </div>

    </div>
    <h6 class="fw-medium fs-16 mb-2 d-none d-md-block">Millions of cheap flights. One simple search</h6>
  </div>
  <div class="normal-trip">
    <div class="d-lg-flex">
      <div class="d-flex  form-info" >

        <ng-container formArrayName="OriginDestinationInfo">
          <ng-container [formGroupName]="0">

            <div class="form-item dropdown">
              <app-location-picker
                #originPicker
                label="From"
                formControlName="airportOriginCode"
                [excludeAirport]="selectedDestination"
              >
                <i class="fa-solid fa-plane-departure me-2 text-muted" aria-hidden="true" location-picker-icon></i>
              </app-location-picker>
            </div>

            <div class="form-item dropdown ps-2 ps-sm-3">
              <app-location-picker #destinationPicker label="To" formControlName="airportDestinationCode" [excludeAirport]="selectedOrigin">
                <i class="fa-solid fa-plane-arrival me-2 text-muted" aria-hidden="true" location-picker-icon></i>
              </app-location-picker>
              <button type="button" class="way-icon badge badge-primary rounded-pill translate-middle" aria-label="Swap origin and destination" (click)="swapAirports(); $event.stopPropagation()">
                <i class="fa-solid fa-arrow-right-arrow-left" aria-hidden="true"></i>
              </button>
            </div>

            <!-- Date Picker Container -->
            <div class="date-picker-container" style="position: relative;">
              <!-- Hidden Date Range Picker for Round Trip -->
              <input type="text"
                *ngIf="journeyType === journeyTypeEnum.ROUND_TRIP"
                style="position: absolute; top: 0; left: 0; width: 1px; height: 1px; opacity: 0; pointer-events: none;"
                bsDaterangepicker
                #dateRangePicker="bsDaterangepicker"
                [bsConfig]="bsRangeConfig"
                [minDate]="bsValue"
                (bsValueChange)="onDateRangeChange($event)" />

              <!-- Hidden Single Date Picker for OneWay -->
              <input type="text"
                *ngIf="journeyType === journeyTypeEnum.ONEWAY"
                style="position: absolute; top: 0; left: 0; width: 1px; height: 1px; opacity: 0; pointer-events: none;"
                bsDatepicker
                #singleDatePicker="bsDatepicker"
                [bsConfig]="bsConfig"
                [minDate]="bsValue"
                (bsValueChange)="onSingleDateChange($event)" />

              <div class="form-item position-relative">
                <label class="form-label fs-14 text-default mb-1" for="flight-departure-input">Departure</label>
                <input id="flight-departure-input" type="text" class="form-control datetimepicker"
                  readonly
                  [value]="getFormattedDate('departureDate')"
                  (click)="openDatePicker($event)"
                  [placeholder]="bsValue | date:'dd-MM-yyyy'" />
                <i class="fa-regular fa-calendar-days" aria-hidden="true" style="position: absolute; right: 0px; top: 38px; color: #6c757d;"></i>
                <p class="fs-12 mb-0">{{ getDateLabel('departureDate') }}</p>
              </div>

              <div class="form-item position-relative round-drip" [ngStyle]="{'display':journeyType === journeyTypeEnum.ROUND_TRIP ? 'block' : 'none'}">
                <label class="form-label fs-14 text-default mb-1" for="flight-return-input">Return</label>
                <input id="flight-return-input" type="text" class="form-control datetimepicker"
                  readonly
                  [value]="getFormattedDate('returnDate')"
                  (click)="openDatePicker($event)"
                  placeholder="21-10-2024" />
                <i class="fa-regular fa-calendar-days" aria-hidden="true" style="position: absolute; right: 0px; top: 38px; color: #6c757d;"></i>
                <p class="fs-12 mb-0">{{ getDateLabel('returnDate') }}</p>
              </div>
            </div>

          </ng-container>
        </ng-container>

    <div class="form-item dropdown" >
      <div class="position-relative" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="menu" (click)="onTravellerToggle($event)">
            <span class="form-label fs-14 text-default mb-1">Travellers and cabin class</span>
            <h5>{{ totalGuestCount }} <span class="fw-normal fs-14">{{ totalGuestCount === 1 ? 'Person' : 'Persons' }}</span></h5>
            <p class="fs-12 mb-0">{{ guestDesc }}</p>
      <i class="fa-solid fa-chevron-down" aria-hidden="true" style="position:absolute; right: 8px; bottom: 8px; color:#6c757d;"></i>
          </div>
          <div class="dropdown-menu dropdown-menu-end dropdown-xl">
            <h5 class="mb-3">Select Travelers & Class</h5>
            <div class="mb-3 border br-10 info-item pb-1">
              <h6 class="fs-16 fw-medium mb-2">Travellers</h6>
              <div class="row" >
                <div class="col-md-4">
                  <div class="mb-3">
          <span class="form-label text-gray-9 mb-2">Adults <span class="text-default fw-normal">(
            12+ Yrs )</span></span>
                    <app-common-counter [MIN]="1" [MAX]="9" formControlName="adults" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
          <span class="form-label text-gray-9 mb-2">Childrens <span
            class="text-default fw-normal">( 2-12 Yrs )</span></span>
                    <app-common-counter formControlName="childs"/>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
          <span class="form-label text-gray-9 mb-2">Infants<span class="text-default fw-normal">(
            0-2 Yrs )</span></span>
                    <app-common-counter formControlName="infants"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 border br-10 info-item pb-1">
              <h6 class="fs-16 fw-medium mb-2">Travellers</h6>
              <div class="d-flex align-items-center flex-wrap">
                <div class="form-check me-3 mb-3">
                  <input class="form-check-input" type="radio" id="economy"
                    [value]="flightType.ECONOMY"
                    [checked]="flightForm.value.class === flightType.ECONOMY"
                    formControlName="class"
                  />
                  <label class="form-check-label" for="economy">
                    Economy
                  </label>
                </div>
                <div class="form-check me-3 mb-3">
                   <input class="form-check-input" type="radio"
                    [value]="flightType.PREMIUM_ECONOMY"
                    [checked]="flightForm.value.class === flightType.PREMIUM_ECONOMY"
                    formControlName="class"
                    id="premium-economy">
                  <label class="form-check-label" for="premium-economy">
                    Premium Economy
                  </label>
                </div>
                <div class="form-check me-3 mb-3">
                  <input class="form-check-input" type="radio"
                    [value]="flightType.BUSINESS"
                    [checked]="flightForm.value.class === flightType.BUSINESS"
                    formControlName="class"
                    id="business">
                  <label class="form-check-label" for="business">
                    Business
                  </label>
                </div>
                <div class="form-check mb-3">
                  <input class="form-check-input" type="radio"
                    [value]="flightType.FIRST_CLASS"
                    [checked]="flightForm.value.class === flightType.FIRST_CLASS"
                    formControlName="class"
                    id="first-class"
                  />
                  <label class="form-check-label" for="first-class">
                    First Class
                  </label>
                </div>
              </div>
            </div>

          </div>
          <!-- Mobile fullscreen overlay (appears only on small screens) -->
          <div class="mobile-travellers-overlay" *ngIf="mobileTravellersOpen">
            <div class="mobile-travellers-panel">
              <button type="button" class="close-mobile" aria-label="Close" (click)="closeMobileTravellers()">✕</button>
              <h5 class="mb-3">Select Travelers & Class</h5>
              <div class="mb-3 border br-10 info-item pb-1">
                <h6 class="fs-16 fw-medium mb-2">Travellers</h6>
                <div class="row" >
                  <div class="col-12">
                    <div class="mb-3">
                      <span class="form-label text-gray-9 mb-2">Adults <span class="text-default fw-normal">( 12+ Yrs )</span></span>
                      <app-common-counter [MIN]="1" [MAX]="9" formControlName="adults" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <span class="form-label text-gray-9 mb-2">Childrens <span class="text-default fw-normal">( 2-12 Yrs )</span></span>
                      <app-common-counter formControlName="childs"/>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <span class="form-label text-gray-9 mb-2">Infants<span class="text-default fw-normal">( 0-2 Yrs )</span></span>
                      <app-common-counter formControlName="infants"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3 border br-10 info-item pb-1">
                <h6 class="fs-16 fw-medium mb-2">Cabin Class</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <div class="form-check me-3 mb-3">
                    <input class="form-check-input" type="radio" id="economy-mobile"
                      [value]="flightType.ECONOMY"
                      [checked]="flightForm.value.class === flightType.ECONOMY"
                      formControlName="class"
                    />
                    <label class="form-check-label" for="economy-mobile">Economy</label>
                  </div>
                  <div class="form-check me-3 mb-3">
                    <input class="form-check-input" type="radio" id="premium-economy-mobile"
                      [value]="flightType.PREMIUM_ECONOMY"
                      [checked]="flightForm.value.class === flightType.PREMIUM_ECONOMY"
                      formControlName="class"
                    />
                    <label class="form-check-label" for="premium-economy-mobile">Premium Economy</label>
                  </div>
                  <div class="form-check me-3 mb-3">
                    <input class="form-check-input" type="radio" id="business-mobile"
                      [value]="flightType.BUSINESS"
                      [checked]="flightForm.value.class === flightType.BUSINESS"
                      formControlName="class"
                    />
                    <label class="form-check-label" for="business-mobile">Business</label>
                  </div>
                  <div class="form-check mb-3">
                    <input class="form-check-input" type="radio" id="first-class-mobile"
                      [value]="flightType.FIRST_CLASS"
                      [checked]="flightForm.value.class === flightType.FIRST_CLASS"
                      formControlName="class"
                    />
                    <label class="form-check-label" for="first-class-mobile">First Class</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-primary search-btn rounded d-flex align-items-center justify-content-center" [disabled]="isInValid || isLoading" (click)="onSearch()">
        <output *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" aria-live="polite"></output>
        <span *ngIf="!isLoading">Search</span>
        <span *ngIf="isLoading">Loading...</span>
      </button>
    </div>
  </div>

</form>
